import { AxiosInstance, InternalAxiosRequestConfig, AxiosRequestHeaders } from "axios";
import { clientId } from "@/account/use-user-account";

export const playerIdInterceptor = (config: InternalAxiosRequestConfig) => {
    if (clientId.value) {
        config.headers ??= {} as AxiosRequestHeaders;
        config.headers["X-PLAYER-ID"] = clientId.value;
    }

    return config;
};

export const addPlayerIdInterceptor = (httpClient: AxiosInstance) => {
    httpClient.interceptors.request.use(playerIdInterceptor, null, { synchronous: true });
};
